import React from 'react'
import { Route, Switch } from 'react-router-dom'
import '../myproducts.css'
import ProductDetailPanel from './ProductDetailPanel'
import ProductMappings from '../ProductMappings/ProductMappings'
import { PATH } from '../../../../app/routes'

const ProductDetail = () => (
    <Switch>
        {/* Mappings opens in its own full-page layout (entities sidebar + mapping canvas) */}
        {/* Mappings: the virtual entities (Payment, Shipping, Sales Person) */}
        <Route path={PATH.PRODUCT_MAPPINGS} render={() => <ProductMappings mode="virtual" title="Mappings" />} />
        {/* Attribute Mappings: the normal entities (Product, Customer, ...) */}
        <Route path={PATH.PRODUCT_ATTRIBUTE_MAPPINGS} render={() => <ProductMappings title="Attribute Mappings" />} />
        <Route>
            <div className="main-content myProducts newMyProducts">
                <div className="page-content pb-0">
                    <div className="container-fluid">
                        <ProductDetailPanel />
                    </div>
                </div>
            </div>
        </Route>
    </Switch>
)

export default ProductDetail
